import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { HttpService } from '../../common-service/http.service';
import { LocalStorageService } from '../../common-service/local-storage.service';

@Injectable({
  providedIn: 'root'
})
export class ProfileService {

  public onUserChange: BehaviorSubject<any>;

  constructor(private _httpService: HttpService, private http: HttpClient, private _localStorageService: LocalStorageService) { this.onUserChange = new BehaviorSubject(null) }
  getUserById() {
    let params = new HttpParams();
    params = params.set('id', this._localStorageService.getStorage('id'));

    return new Promise((resolve, reject) => {
      this._httpService.get('getUser' + "?" + params).subscribe((data: any) => {
        if (data.status_code == 200) {
          resolve(data.data)
          this.onUserChange.next(data.data[0])
        }
        else {
          reject(data.data)
        }
      }, (error) => {
        reject(error)
      })
    })
  }


}
